import React from "react"
import styles from "./styles.scss"
import Dropdown from "../Dropdown"
import jwtDecode from "jwt-decode"
import { connect } from 'react-redux'
import { logout } from 'data/auth'

class AdminHeader extends React.Component {
  state = {
    userName: ''
  }

  componentDidMount() {
    const token = localStorage.getItem("token")
    const name = (jwtDecode(token)).unique_name
    this.setState({ userName: name})
  }
  handleLogoutClick = () => {
    window.confirm("Logga ut?") &&
      this.props.logout()
  }
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.headerText}>
              <p className={styles.adminText}>Administration</p>
              <p>
                Lägg till, redigera eller ta bort företag, kategorier och
                annonser.
              </p>
            </div>
            <div className={styles.menuButtons}>
            <p>{this.state.userName}</p>
            <a className={styles.logoutLink} onClick={this.handleLogoutClick}>logga ut</a>
            <Dropdown />
            </div>
      </div>
    )
  }
}

export default connect(
  null,
  {
    logout,
  })(AdminHeader)



// WEBPACK FOOTER //
// src/pages/Admin/components/AdminHeader/index.jsx